import MainMenu from '@/components/foundation/main-menu/MainMenu'
import ItemAnalysis from '@/view/item-analysis/ItemAnalysis'

export default {
  path: '/item-analysis',
  name: 'ItemAnalysis',
  components: {
    default: ItemAnalysis,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'event',
    area: 'event',
    breadcrumb: [
      {
        name: 'Analise de Item'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/item/ItemAnalysisRoute.js